module.exports = __webpack_public_path__ + "static/getting-things-done-56ac1d33bac582fa9ee8872239ba960b.jpg";